import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [entitlement, setEntitlement] = useState(null);

  const refreshEntitlement = useCallback(async (signedIn) => {
    const path = signedIn ? "/billing/me" : "/billing/guest";
    try {
      const { data } = await api.get(path);
      setEntitlement(data);
    } catch {
      setEntitlement(null);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      refreshEntitlement(true);
    } catch {
      setUser(null);
      refreshEntitlement(false);
    } finally {
      setLoading(false);
    }
  }, [refreshEntitlement]);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
    refreshEntitlement(false);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, checkAuth, logout, entitlement, refreshEntitlement: () => refreshEntitlement(!!user) }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
